/**
 * The same normalisation the server applies, so what a teacher sees while
 * typing matches what will be stored.
 *
 * Kept deliberately small and mirrored rather than shared: the server is the
 * authority and validates again, and a shared package for forty lines would
 * cost more than it saves.
 */
export const DEFAULT_COUNTRY_CODE = '998';

export function normalisePhone(input: string): string | null {
  const trimmed = (input ?? '').trim();
  if (!trimmed) return null;

  const hadPlus = trimmed.startsWith('+');
  let digits = trimmed.replace(/\D/g, '');
  if (!digits) return null;

  if (!hadPlus) {
    if (digits.startsWith('00')) digits = digits.slice(2);
    else if (digits.length === 10 && digits.startsWith('8')) digits = DEFAULT_COUNTRY_CODE + digits.slice(1);
    else if (digits.length === 9) digits = DEFAULT_COUNTRY_CODE + digits;
  }

  // Six at the least, so a candidate number can be a sign-in number.
  if (digits.length < 6 || digits.length > 15) return null;
  return `+${digits}`;
}

/** +998 90 123 45 67 — how people write it here. */
export function formatPhone(value: string | null | undefined): string {
  if (!value) return '—';
  const digits = value.replace(/\D/g, '');
  // A short sign-in number is shown as typed, not dressed as a phone.
  if (digits.length < 8) return digits;
  if (digits.startsWith(DEFAULT_COUNTRY_CODE) && digits.length === 12) {
    const rest = digits.slice(3);
    return `+${DEFAULT_COUNTRY_CODE} ${rest.slice(0, 2)} ${rest.slice(2, 5)} ${rest.slice(5, 7)} ${rest.slice(7)}`;
  }
  return `+${digits}`;
}

export const isPhone = (input: string): boolean => normalisePhone(input) !== null;
